// https://tkdodo.eu/blog/effective-react-query-keys#structure
const queryKeys = {
  all: ["users"] as const,
  profile: (id?: string) => [...queryKeys.all, "profile", id] as const,
  steamConnection: () => [...queryKeys.all, "connections", "steam"] as const,
};

export { queryKeys };
